import {WorkspaceId} from "@/sdk.ts";
import {RouteLocationRaw, Router, RouteRecordRaw} from "vue-router";
import {defineAsyncComponent} from "vue";
import {getAccountProfileRouteRecord, getAccountProfileRouteLocation} from "./-profile/routes";
import {getAccountLegalTermsRouteRecord} from "./-legal/routes";
import {getAccountTermsOfServiceRouteRecord} from './-terms_of_service/routes'
import {getAccountCreditsRouteRecord} from './-credits/routes'
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories";
import {PageHeaderConfig} from "@/components/navigation/usePageHeader";
import {i18n} from "@/i18n";
import router from "@/router";

export namespace AccountRoute {
  export function record(): RouteRecordRaw {
    return {
      name: 'account',
      path: '/workspace/:workspaceId/account',
      component: customAsyncComponent(async () => import('./views/AccountView.vue')),
      children: [
        getAccountProfileRouteRecord(),
        getAccountLegalTermsRouteRecord(),
        getAccountTermsOfServiceRouteRecord(),
        getAccountCreditsRouteRecord(),
      ],
      redirect: to => {
        return getAccountProfileRouteLocation(parseInt(to.params.workspaceId as string))
      },
      meta: {
        navLoader: true,
        hasNav: true,
        forceMe: true,
        requiresAuth: true,
        localeCategories: [
          LOCALE_CATEGORIES.MY_ACCOUNT,
          LOCALE_CATEGORIES.ERRORS,
          LOCALE_CATEGORIES.NAVIGATION,
        ]
      }
    }
  }

  export function location(params: { workspaceId: WorkspaceId; }): RouteLocationRaw {
    return {name: 'account', params}
  }

  export function getParams(router: Router): { workspaceId: WorkspaceId; } {
    return {
      workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
    }
  }

  export function getHeaderConfig(workspaceId: number): PageHeaderConfig {
    return {
      showHome: true,
      showTitle: false,
      title: '',
      breadcrumb: [
        {
          label: i18n.global.t('navigation.account'),
          route: getAccountRouteLocation({workspaceId})
        }
      ]
    }
  }
}

export function getAccountRouteRecord(): RouteRecordRaw {
  return {
    name: 'account',
    path: '/workspace/:workspaceId/account',
    component: customAsyncComponent(async () => import('./views/AccountView.vue')),
    children: [
      getAccountProfileRouteRecord(),
      getAccountLegalTermsRouteRecord(),
      getAccountTermsOfServiceRouteRecord(),
      getAccountCreditsRouteRecord(),
    ],
    redirect: to => {
      return getAccountProfileRouteLocation(parseInt(to.params.workspaceId as string))
    },
    meta: {
      navLoader: true,
      hasNav: true,
      forceMe: true,
      requiresAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.MY_ACCOUNT,
        LOCALE_CATEGORIES.ERRORS,
        LOCALE_CATEGORIES.NAVIGATION,
      ]
    }
  }
}

export function getAccountRouteLocation(params: { workspaceId: WorkspaceId; }): RouteLocationRaw {
  return {name: 'account', params}
}

export function getAccountRouteParams(router: Router): { workspaceId: WorkspaceId; } {
  return {
    workspaceId: parseInt(router.currentRoute.value.params.workspaceId as string, 10),
  }
}

export function getAccountPageHeaderConfig(workspaceId: number): PageHeaderConfig {
  return {
    showHome: true,
    showTitle: false,
    title: '',
    breadcrumb: [
      {
        label: i18n.global.t('navigation.account'),
        route: getAccountRouteLocation({workspaceId})
      }
    ]
  }
}